import { Product } from '../types/Product';
import { normalizeText } from './text';

const MIN_SEARCH_LENGTH = 3;

export const searchProducts = (products: Product[], searchTerm: string): Product[] => {
  const normalizedSearch = normalizeText(searchTerm);
  
  if (normalizedSearch.length < MIN_SEARCH_LENGTH) {
    return [];
  }
  
  const searchTerms = normalizedSearch.split(/\s+/);
  
  return products.filter(product => {
    const normalizedName = normalizeText(product.display_name);
    const normalizedBrand = normalizeText(product.brand);
    const normalizedCategory = normalizeText(product.category_name);
    
    return searchTerms.every(term => 
      normalizedName.includes(term) ||
      normalizedBrand.includes(term) ||
      normalizedCategory.includes(term)
    );
  });
};